export interface CoBrowsingCompany {
  label: string;
  value: string;
  id: string;
  companyId: string;
}
